// extracted by mini-css-extract-plugin
export default {"buttonClass":"Contact_buttonClass__+YAwt","submitButton":"Contact_submitButton__4fNM-","address":"Contact_address__sGK3o","form":"Contact_form__c6AsX","email":"Contact_email__Y75+4"};